export const enum TagType {
  UNKNOWN,
  CLASSIFICATION,
  EXPERIENCE
}

export interface TagModel {
  readonly id: string;
  readonly type: TagType;
  readonly label: string;
}
